// extracted by mini-css-extract-plugin
export default {"container":"sectionTitle_container__ewVcV","title":"sectionTitle_title__4zPhM","image":"sectionTitle_image__AGDPS"};